import _bounceOut from "./bounce-out";
var exports = {};
var bounceOut = _bounceOut;

function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}

exports = bounceIn;
export default exports;